import { AppModule } from "@/shared/types";
import DashboardModule from "./Dashboard/dashboard.module";
import LoginModule from "./Login/login.module";
import ReportModule from "./Report/report.module";

const PageModules: AppModule[] = [DashboardModule, LoginModule, ReportModule]

export default PageModules;